import React from 'react';

const JS_Window = () => {
  return (
    <div >
      <h1>JS_Window</h1>
      <p>Placeholder component for: "JS Window"</p>
    </div>
  );
};

export default JS_Window;
